/// <amd-module name="TFS/Admin/Groups/Common/Util/MultiOperationDialogUtil" />
import { IOperationStatus, Result } from "TFS/Admin/Common/Constants/Constants";
import * as Resources from "TFS/Admin/Groups/Common/Resources";

export function getMultiDeletionOperationStatusText(multiOperationStatuses: IOperationStatus[]): string {
    const { anySuccess, anyFailure } = getMultiOperationState(multiOperationStatuses);

    if (!anySuccess) {
        return Resources.DeletionFailure;
    } else if (anyFailure) {
        return Resources.DeletionPartialSuccess;
    }
    return Resources.DeletionSuccess;
}

export function getMembersAddOperationStatusText(multiOperationStatuses: IOperationStatus[]): string {
    const { anySuccess, anyFailure } = getMultiOperationState(multiOperationStatuses);

    if (!anySuccess) {
        return Resources.AddMembersFailedStatus;
    } else if (anyFailure) {
        return Resources.AddMembersPartialSuccessStatus;
    }
    return Resources.AddMembersSuccessStatus;
}

export function getMemberOfAddOperationStatusText(multiOperationStatuses: IOperationStatus[]): string {
    const { anySuccess, anyFailure } = getMultiOperationState(multiOperationStatuses);

    if (!anySuccess) {
        return Resources.AddMemberOfFailedStatus;
    } else if (anyFailure) {
        return Resources.AddMemberOfPartialSuccessStatus;
    }
    return Resources.AddMemberOfSuccessStatus;
}

function getMultiOperationState(multiOperationStatuses: IOperationStatus[]): { anySuccess: boolean; anyFailure: boolean } {
    let anySuccess = false;
    let anyFailure = false;
    for (const operation of multiOperationStatuses) {
        if (operation.value === Result.Success) {
            anySuccess = true;
        } else {
            anyFailure = true;
        }
        if (anyFailure && anySuccess) break;
    }
    return { anySuccess, anyFailure };
}
